import React, { useEffect } from 'react';
import Layout from '../layout/Layout';
import { usePageContent } from '../../context/ContentContext';

const DesignAndDevelopment = () => {
    const { t, g } = usePageContent('designDevelopment');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Layout>
            {/* Hero Section */}
            <section className="relative h-[70vh] overflow-hidden">
                <img
                    src={t('hero.image')}
                    alt={t('hero.title')}
                    className="absolute inset-0 w-full h-full object-cover"
                />
                {/* Lighter gradient overlay for navbar contrast */}
                <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/15 to-transparent"></div>
                <div className="absolute inset-0 bg-black bg-opacity-25 flex items-center justify-center">
                    <h1 className="font-poppins font-light text-h1 text-white text-center px-4">
                        {t('hero.title')}
                    </h1>
                </div>
            </section>

            {/* Introduction */}
            <section className="py-20 bg-white">
                <div className="container mx-auto px-4">
                    <div className="max-w-4xl mx-auto text-center">
                        <h2 className="font-poppins font-light text-h2 mb-8 text-primary-dark-red">
                            {t('intro.title')}
                        </h2>
                        <div className="font-poppins font-normal text-body">
                            {t('intro.paragraphs').map((paragraph, index) => (
                                <p key={index} className="mb-6">{paragraph}</p>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* Design Services */}
            <section className="py-20 bg-background-cool-blue">
                <div className="container mx-auto px-4">
                    <h2 className="font-poppins font-light text-h2 text-center mb-12 text-primary-dark-red">
                        {t('services.title')}
                    </h2>

                    <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
                        {t('services.cards').map((card, index) => (
                            <div key={index} className="bg-white p-8 rounded-lg shadow-sm">
                                <h3 className="font-poppins font-semibold text-h3 mb-4 text-primary-red">
                                    {card.title}
                                </h3>
                                <p className="font-poppins font-normal text-body mb-4">
                                    {card.body}
                                </p>
                                <ul className="font-poppins font-normal text-sub space-y-2">
                                    {(card.bullets || []).map((bullet, bulletIndex) => (
                                        <li key={bulletIndex}>• {bullet}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Development Process */}
            <section className="py-20 bg-white">
                <div className="container mx-auto px-4">
                    <h2 className="font-poppins font-light text-h2 text-center mb-12 text-primary-dark-red">
                        {t('process.title')}
                    </h2>

                    <div className="max-w-4xl mx-auto">
                        <div className="space-y-8">
                            {t('process.steps').map((step, index) => (
                                <div key={index} className="flex items-start">
                                    <div className="flex-shrink-0 mr-6 w-20 h-20 flex items-center justify-center">
                                        <img src={step.image} alt={step.title} className="h-16 w-auto object-contain" />
                                    </div>
                                    <div>
                                        <h3 className="font-poppins font-semibold text-h3 mb-2 text-primary-red">
                                            {step.title}
                                        </h3>
                                        <p className="font-poppins font-normal text-body">
                                            {step.body}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* Call to Action */}
            <section className="py-20 bg-primary-dark-red text-white">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="font-poppins font-light text-h2 mb-6">
                        {t('cta.title')}
                    </h2>
                    <p className="font-poppins font-normal text-body max-w-2xl mx-auto mb-10">
                        {t('cta.body')}
                    </p>
                    <a
                        href={`mailto:${g('contact.email')}`}
                        className="inline-block px-8 py-4 bg-primary-red text-white hover:bg-pink-600 transition-colors duration-300 font-poppins font-semibold text-h3 rounded-lg"
                    >
                        {t('cta.buttonText')}
                    </a>
                </div>
            </section>
        </Layout>
    );
};

export default DesignAndDevelopment;
